import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router";
import { DetailSection } from "../../portfolio/portfolioView/styled";

import { BsClock } from "react-icons/bs";
import { SiAnswer } from "react-icons/si";

import moment from "moment";

const Viewer = ({ data, handleDeleteInquiry, handleEdit, contentRef }) => {
  const navigate = useNavigate();
  const { theme, url } = useOutletContext();

  return (
    <DetailSection className={`theme-${theme}`}>
      <div className="info">
        <p>{data?.title}</p>
        <div className="details">
          <span>
            <SiAnswer />
            <div className={`status ${data?.status ? "completion" : "pending"}`}>
              {data?.status ? "답변완료" : " 대기"}
            </div>
          </span>
          <span>
            <BsClock /> {moment(data?.updateDt || data?.createDt).format("YYYY-MM-DD HH:mm:ss")}
          </span>
        </div>
        <div className="action">
          <button onClick={() => handleEdit()}>수정</button>
          <button onClick={() => handleDeleteInquiry()}>삭제</button>
        </div>
      </div>
      <div className="contents" ref={contentRef}>
        <div dangerouslySetInnerHTML={{ __html: data?.content || "" }}></div>
      </div>
      {data?.answer ? (
        <div className="contents answer">
          <span className="date">{moment(data?.answeredAt).format("YYYY-MM-DD HH:mm:ss")}</span>
          <div dangerouslySetInnerHTML={{ __html: data.answer || "" }}></div>
        </div>
      ) : (
        <div className="contents answer not">답변이 존재하지 않습니다.</div>
      )}
      <div className="buttons">
        <button
          onClick={() =>
            navigate(`/shop/${url}/shoppingNotice?page=0`, { state: { tabIndex: 1 } })
          }>
          목록
        </button>
      </div>
    </DetailSection>
  );
};

export default Viewer;
